module.exports = __webpack_public_path__ + "static/media/sbom-slide-8.2e706086.jpg";